export default "Three hyphens on a line create a divider.\n\n---\n\nAlternatively, asterisks can be used.\n\n***\n";